<template>

    <el-row>
        <el-col :span="14">
            <div class="clue-wrapper">
                <div class="clue-view-border">
                    <h5>客户资料</h5>
                    <div class="userInfo-group">
                        <span>客户信息</span>
                        <el-row>
                            <el-col :span="8" class="order-item">
                                <label>客户名称：</label>
                                <span>{{customer.name}}</span>
                            </el-col>
                            <el-col :span="8" class="order-item">
                                <label>客户类型：</label>
                                <span>{{customer.type_name}}</span>
                            </el-col>
                            <el-col :span="8" class="order-item">
                                <label>所在地：</label>
                                <span v-if="customer.city_id > 0 && Acs('/customers/done')">
                                    <i style="color: #F56C6C;" class="el-icon-location-outline"></i>
                                        <router-link target="_blank" title="点击查看周边成交"
                                                     :to="{path: '/customers/done', query: {province_id: customer.province_id, city_id: customer.city_id,district_id: customer.district_id}}">
                                            {{customer.district_names}}
                                        </router-link>
                                </span>
                                <span v-else>
                                    <i style="color: #F56C6C;" class="el-icon-location-outline"></i>
                                    {{customer.district_names}}
                                </span>

                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8" class="order-item">
                                <label>客户级别：</label>
                                <span v-show="!level_edit">{{customer.level_name}}
                                    <span v-if="isEdit" @click="edit_customer('level_edit') " style="color: #409EFF" class="el-icon-edit">修改</span>
                                </span>
                                <el-select v-show='level_edit' ref="level_edit" size="mini" @change="save_customer_level" @blur="level_edit=false"  v-model="customer.level_name" placeholder="请选择" style="width:100px">
                                    <el-option v-for="(item, key) in levels" :key="key" :label="item" :value="key">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="8" class="order-item">
                                <label>成熟度：</label>
                                <span v-show="!maturity_edit">
                                    {{customer.maturity_name}}
                                    <span v-if="isEdit" @click="edit_customer('maturity_edit') " style="color: #409EFF" class="el-icon-edit">修改</span>
                                </span>
                                <el-select v-show='maturity_edit' ref="maturity_edit" size="mini" @change="save_customer_maturity" @blur="maturity_edit=false"  v-model="customer.maturity" placeholder="请选择" style="width:100px">
                                    <el-option v-for="(item, key) in maturitys" :key="key" :label="item" :value="key">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="8" class="order-item">
                                <label>是否回访：</label>
                                <span v-show="!is_visit">{{customer.is_visit == 1 ? '需要回访' : '不需要回访'}}
                                    <span v-if="isEdit" @click="edit_customer('is_visit') " style="color: #409EFF" class="el-icon-edit">修改</span>
                                </span>
                                <el-select v-show='is_visit' ref="is_visit" size="mini" @blur="is_visit=false" @change="save_customer_visit" v-model="customer.is_visit" placeholder="请选择" style="width:110px">
                                    <el-option  label="需要回访" value="1">需要回访</el-option>
                                    <el-option  label="不需要回访" value="0">不需要回访</el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8" class="order-item">
                                <label>学校班级数：</label>
                                <span v-show="!class_num_edit">{{customer.class_num ? customer.class_num : '暂无相关信息'}}
                                    <span v-if="isEdit" @click="edit_customer('class_num_edit')" style="color: #409EFF" class="el-icon-edit">修改</span>
                                </span>
                                <el-input v-show="class_num_edit" ref="class_num_edit" size="mini" v-model="customer.class_num" @blur="save_customer_class_num" style="width: 100px"></el-input>
                            </el-col>
                            <el-col :span="8" class="order-item">
                                <label>学校老师数：</label>
                                <span v-show="!teacher_num_edit">{{customer.teacher_num ? customer.teacher_num : '暂无相关信息'}}
                                    <span v-if="isEdit" @click="edit_customer('teacher_num_edit')" style="color: #409EFF" class="el-icon-edit">修改</span>
                                </span>
                                <el-input  ref="teacher_num_edit"  v-show="teacher_num_edit" size="mini" v-model="customer.teacher_num" @blur="save_customer_teacher_num" style="width: 100px"></el-input>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="6" class="order-item">
                                <label>是否开设高中：</label>
                                <span>{{customer.is_high_school_name}}</span>
                            </el-col>
                            <el-col :span="6" class="order-item">
                                <label>是否开设初中：</label>
                                <span>{{customer.is_middle_school_name}}</span>
                            </el-col>
                            <el-col :span="6" class="order-item">
                                <label>是否开设小学：</label>
                                <span>{{customer.is_grade_school_name}}</span>
                            </el-col>
                            <el-col :span="6" class="order-item">
                                <label>是否开设中职：</label>
                                <span>{{customer.is_vsh_school_name}}</span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8" class="order-item">
                                <label>创建时间：</label>
                                <span>{{customer.created_at}}</span>
                            </el-col>
                            <el-col :span="8" class="order-item">
                                <label>最后更新时间：</label>
                                <span>{{customer.updated_at}}</span>
                            </el-col>
                            <el-col :span="8" class="order-item">
                                <label>绑定时间：</label>
                                <span>{{customer.bind_at}}</span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24" class="order-item">
                                <label>备注信息：</label>
                                <span>{{customer.memo}}</span>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="userInfo-group">
                        <span>业务员信息</span>
                        <el-row>
                            <el-col :span="12" class="order-item">
                                <label>业务员：</label>
                                <span>{{customer.username}}</span> 
                            </el-col>
                        </el-row>
                        <Cooperator :customer_id="customer.id"></Cooperator>
                    </div>

                    <div class="userInfo-group">
                        <span>联系人</span>
                        <el-row>
                            <el-button v-if="isEdit" type="primary" size="mini" @click="createContact">新增联系人</el-button>
                        </el-row>
                        <el-row>
                            <el-table v-loading="contactsLoading" :data="contacts" style="width: 100%" size="mini">
                                <el-table-column prop="name" label="客户" width="100" v-if="customer.child">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.customer_name}}</span><span v-if="scope.row.customer_id==customer.id" style="color: red">（主）</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="name" label="姓名" width="100">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.name}}</span><span v-if="scope.row.status==1" style="color: red">（关键）</span>
                                    </template>
                                </el-table-column>
                                <el-table-column width="60" prop="job_name" label="职务"></el-table-column>
                                <el-table-column prop="mobile" label="手机/电话">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.mobile}}</span><br>
                                        <span>{{scope.row.phone_number}}</span>
                                        <el-button v-if="scope.row.mobile != '' || scope.row.phone_number != ''" type="text" size="mini" icon="el-icon-unlock" @click="unlockMobile(scope.row)">解密</el-button>
                                    </template >
                                </el-table-column>
                                <el-table-column prop="products" label="意向产品">
                                    <template slot-scope="scope">
                                        <span v-for="(item, index) in scope.row.products" :key="index">{{item.product_name}}<br/></span>
                                    </template>
                                </el-table-column>
                                <el-table-column width="70" prop="leads_id" label="线索ID">
                                    <template slot-scope="scope">
                                        <span class="el-dropdown-link">
                                            <router-link type="primary" target="_blank" :to="{path: '/sales-leads/view', query: {id: scope.row.leads_id}}" style="color:#409eff">
                                                {{scope.row.leads_id}}
                                            </router-link>
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="created_at" label="申请/创建时间"></el-table-column>
                                <el-table-column prop="leads_status_str" label="真实性">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.leads_status_str}}</span>
                                        <span v-if="Acs('/contacts/change-lead-status')" @click="edit_contact(scope.row)" style="color: #409EFF" class="el-icon-edit"></span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作">
                                    <template slot-scope="scope">
                                        <el-button v-if="isEdit && scope.row.customer_id==customer.id" @click="updateContact(scope.row)" type="text"  size="small">编辑</el-button>
                                        <el-button v-if="isEdit && Acs('/contacts/delete') && scope.row.customer_id==customer.id" @click="handleDelete(scope.row)" type="text"  size="small">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-row>
                        <el-row v-if="contactLinkPage">
                            <pagination :linkPage="contactLinkPage" :enableEvent="true" @change="watchContactsPageChange"></pagination>
                        </el-row>
                    </div>

                    <!--新增联系人与编辑联系人的对话框-->
                    <contact-form v-if="showContactForm"
                                  :customerId="customerId"
                                  :contactId="contactId"
                                  :isShowCustomerName="true"
                                  :isUpdateCustomerName="false"
                                  :customerName="customer.name"
                                  :contact="contactObj"
                                  :contactsList="contacts"
                                  @changeShow="changeShow"
                                  @changeCreate="changeCreate"
                                  @changeUpdate="changeUpdate"
                    ></contact-form>

                    <el-row></el-row>
                    <el-row></el-row>
                    <el-row></el-row>
                    <el-row></el-row>
                </div>
            </div>
        </el-col>

        <el-col :span="10">
            <div class="clue-wrapper">
                <div class="clue-view-border">
                    <h5>客户跟进</h5>
                    <div class="userInfo-group" v-if="isEdit">
                        <el-form ref="form" :model="traceModel" :rules="traceFormRules" label-width="100px">
                            <el-form-item label="跟进产品" prop="product_id">
                                <el-select v-model="traceModel.product_id" placeholder="请选择跟进产品" size="small" multiple>
                                    <el-option v-for="product in products" :key="parseInt(product.id)" :label="product.name" :value="product.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="联系人" prop="contact_id">
                                <el-select v-model="traceModel.contact_id" placeholder="请选择联系人" size="small">
                                    <el-option v-for="contact in contacts" :key="contact.id" :label="contact.name" :value="contact.id" v-show="contact.customer_id==customer.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="跟进内容" prop="content">
                                <el-input type="textarea" v-model="traceModel.content" size="small"></el-input>
                            </el-form-item>
                            <el-form-item label="下次跟进时间" prop="next_time" size="small">
                                <el-date-picker
                                        v-model="traceModel.next_time"
                                        type="datetime"
                                        placeholder="选择日期时间">
                                </el-date-picker>
                            </el-form-item>

                            <el-form-item>
                                <el-button :loading="submiting" size="small" type="success" @click="submitTrace()">保存跟进</el-button>
                                <el-button size="small" @click="resetForm()">重置</el-button>
                                <el-button type="text" v-if="Acs('/customer-quote/create')" @click="showAddDialog()">添加报价方案</el-button>
                            </el-form-item>
                        </el-form>
                    </div>

                    <div class="order-infoTab-section" v-loading="traceLoading">
                        <el-tabs v-model="activeName" @tab-click="handleClick" v-if="customer.child">
                            <el-tab-pane :label="customer.name" :name="customer.id + ''"></el-tab-pane>
                            <el-tab-pane v-for="child in customer.childs" :key="parseInt(child.id)" :label="child.name" :name="child.id + ''"></el-tab-pane>
                        </el-tabs>
                        <div class="order-bd" >
                            <el-steps direction="vertical">
                                <el-step icon="el-icon-fa-user" v-for="(trace, index) in traces" :key="index" >
                                    <div slot="title" class="title-step" >
                                        <span>{{trace.username}}</span>
                                        <span>联系人：{{trace.contact_name}}</span>
                                        <span>跟进产品：{{trace.product_name}}</span>
                                        <span>跟进时间：{{trace.created_at}}</span>
                                        <span v-if="trace.next_time">下次跟进时间：{{trace.next_time}}</span>
                                    </div>
                                    <div slot="description" class="des-step" >
                                        <div>详细内容：{{trace.content}}</div>
                                    </div>
                                </el-step>
                            </el-steps>
                        </div>

                        <el-row v-if="traceLinkPage">
                            <pagination :linkPage="traceLinkPage" :enableEvent="true" @change="watchTracesPageChange"></pagination>
                        </el-row>
                    </div>

                </div>

            </div>
        </el-col>

        <addQuote v-if="dialogAddQuote" :customer="customer" :model="{}" :key="corpKey" @change="quoteDialogClose()"></addQuote>
        <ContactDialog v-if="contact" ref="ContactDialog" :contact="contact" @change="contactDialogChange" :key="contact_dialog_key"></ContactDialog>
    </el-row>


</template>

<script>
    import CommonService from "~/services/common";
    import ContactService from "~/services/contact";
    import CustomerService from "~/services/customer";
    import CustomerTraceService from "~/services/CustomerTrace";
    import Pagination from "~/widgets/Pagination.vue";
    import ProductService from "~/services/product";
    import ContactForm from "~/views/contact/form.vue";
    import Cooperator from "./cooperator.vue";
    import addQuote from "~/views/customer/dialog/addQuote.vue";
    import ContactDialog from "~/views/customer/dialog/contactDialog.vue";

    const CACHE_NAME = 'traceCache';

    export default {
        name: "Workspace",
        components: {
            Pagination,
            ContactForm,
            Cooperator,
            addQuote,
            ContactDialog
        },
        props: {
            customer: {
                type: Object,
                default: null,
                required: true
            },
            customerId: {
                type: Number,
                default: 0,
                required: true
            },
            isEdit: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                activeName: '',
                level_edit:'',
                levels:[],
                maturity_edit: '',
                maturitys: [],
                is_visit:'',
                class_num_edit:'',
                teacher_num_edit:'',
                customer_level:'',
                products: [],

                traceModel: {
                    id: "",
                    customer_id: "",
                    product_id: [],
                    contact_id: "",
                    content: "",
                    next_time: "",
                },
                submiting: false,
                traceLoading: true,
                traces: [],
                traceLinkPage: null,
                traceFormRules: {
                    content: [
                        {
                            required: true,
                            message: "请输入跟进内容"
                        }
                    ],
                    product_id: [
                        {
                            required: true,
                            message: "必须选择一个产品"
                        }
                    ],
                    contact_id: [
                        {
                            required: true,
                            message: "联系人不能为空"
                        }
                    ]
                },

                contacts: [],
                contactsLoading: false,
                contactLinkPage: null,

                showContactForm: false,
                contactId: '',
                contactObj: null,
                corpKey: 0,
                dialogAddQuote: false,
                contact: null,
                contact_dialog_key: 0,
            }
        },

        created() {
            let cache = this.getCache();
            if (cache != null) {
                this.traceModel = cache;
            }
            this.levels = CustomerService.getLevels();
            if (this.products.length == 0) {
                this.getProducts();
            }

            if (this.contacts.length < 1) {
                this.getContacts({customer_id: this.customerId});
            }

            if (this.traces.length < 1) {
                this.getTraces({customer_id: this.customerId});
            }
            this.maturitys = CustomerService.getMaturity();
            this.activeName = this.customer.id + '';
        },
        watch: {
            'traces': function(value, oldValue) {
                if (value.length == 0) {
                    return;
                }

                if (value[0].contact_id > 0 && this.traceModel.contact_id == "") {
                    this.traceModel.contact_id = value[0].contact_id;
                }

                if (value[0].product_id && this.traceModel.product_id.length == 0) {
                    this.traceModel.product_id = value[0].product_id.split(',');
                }
            },

            'traceModel.content': function (value, oldValue) {
                if (value != '') {
                    //this.$message({message: "已自动缓存"});
                    this.setCache(this.traceModel);
                }
            },

            'traceModel.next_time': function (value, oldValue) {
                if (value != '') {
                    this.setCache(this.traceModel);
                }
            }
        },
        methods: {
            edit_customer($type){
                this[$type]=true
                this.$nextTick(function(){
                    this.$refs[$type].focus();
                })
            },
            save_customer_teacher_num(){
                this.teacher_num_edit = false;
                CustomerService.updateMy(this.customer);
            },
            save_customer_class_num(e){
                this.class_num_edit = false;
                CustomerService.updateMy(this.customer);
            },
            save_customer_visit(e){
                this.customer.is_visit = e;
                this.is_visit = false;
                CustomerService.updateMy(this.customer);
            },
            save_customer_level(e){
                this.customer.level_name = this.levels[e];
                this.customer.level = e;
                this.level_edit = false;
                CustomerService.updateMy(this.customer);
            },
            save_customer_maturity(e){
                this.customer.maturity = e;
                this.customer.maturity_name = this.maturitys[this.customer.maturity];
                this.maturity_edit = false;
                CustomerService.updateMy(this.customer);
            },
            // 得到产品列表
            getProducts() {
                ProductService.getOptionList()
                    .then(res => {
                        if (res && res.data) {
                            this.products = res.data;
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });
            },

            getContacts(params) {
                this.contactsLoading = true;
                CommonService.getContacts(params).then(res => {
                    this.contactsLoading = false;
                    if (res && res.data) {
                        this.contacts = res.data;
                    }
                }).catch(err => {
                    this.contactsLoading = false;
                    console.error(err);
                })
            },

            watchContactsPageChange(pageParams) {
                this.getContacts({
                    customer_id: this.customerId,
                    page: pageParams["page"],
                    perPage: pageParams["perPage"]
                });
            },

            getTraces(params) {
                CustomerTraceService.getList(params).then(res => {
                    if (res && res.data) {
                        this.traces = res.data;
                        if (res._meta) {
                            this.traceLinkPage = res._meta;
                        }
                        this.traceLoading = false;
                    }
                }).catch(err => {
                    this.traceLoading = false;
                    console.error(err);
                })
            },

            watchTracesPageChange(pageParams) {
                this.getTraces({
                    customer_id: this.customerId,
                    page: pageParams["page"],
                    perPage: pageParams["perPage"]
                });
            },

            resetForm() {
                this.removeCache();
                this.$refs["form"].resetFields();
                this.traceModel.content = "";
                this.traceModel.next_time = "";
            },

            submitTrace() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.submiting = true;
                        this.traceModel.customer_id = this.customerId;
                        // 直接提交跟进记录入库
                        CustomerTraceService.create(this.traceModel).then(res => {
                            this.submiting = false;
                            if (res && res.code == 0) {
                                this.$message({type: "success", message: "创建跟进成功!"});
                                this.getTraces({customer_id: this.customerId});
                                this.resetForm();
                            }
                        }).catch(err => {
                            this.submiting = false;
                            console.error(err);
                        })
                    } else {
                        return;
                    }
                });
            },

            getCacheKey() {
                return CACHE_NAME + '-' + this.customerId;
            },

            setCache(value) {
                let storage = localStorage;
                storage.setItem(this.getCacheKey(), JSON.stringify(value))
                return;
            },

            getCache() {
                let storage = localStorage;
                let result =  storage.getItem(this.getCacheKey());
                return JSON.parse(result);
            },

            clearCache() {
                let storage = localStorage;
                storage.clear();
                return;
            },

            removeCache() {
                let storage = localStorage;
                return storage.removeItem(this.getCacheKey())
            },

            //新增联系人，展示Dialog对话框
            createContact() {
                this.showContactForm = true;
                this.contactId = '';
                this.contactObj = null;
                // this.customeId = this.customerId;
            },

            //修改联系人，展示Dialog对话框
            updateContact(contact) {
                this.showContactForm = true;
                this.contactId = contact.id;
                this.contactObj = contact;
            },

            //form dialog 的回调 start

            //关闭dialog窗口更新showForm值
            changeShow(isShow) {
                this.showContactForm = isShow;
                this.contactObj = null;
            },

            //新增后列表中增加展示新数据
            changeCreate(contact) {
                // this.contacts.unshift(contact);
                this.getContacts({customer_id: this.customerId});
            },

            //编辑后列表数据立即更新
            changeUpdate(obj) {
                this.getContacts({customer_id: this.customerId});
            },

            handleDelete(contact) {
                let _this = this;
                _this.$confirm('此操作将永久删除该联系人, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    ContactService.delete(contact.id).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.getContacts({customer_id: this.customerId});
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },

            unlockMobile(contact) {
                ContactService.decodeMobile({id: contact.id, type: 2}).then(res => {
                    if (res.code == 0 && res.data) {
                        this.$message.success("解密成功！");
                        contact.mobile = res.data.mobile;
                        contact.phone_number = res.data.phone_number;
                    }
                })
            },
            handleClick(tab, event) {
                this.traceLoading = true;
                this.getTraces({customer_id: parseInt(tab.name)});
            },
            showAddDialog(){
                this.model = {};
                this.dialogAddQuote = true;
                this.corpKey += 1;
            },
            quoteDialogClose(val){
                this.dialogAddQuote = false;
                this.submitSearch();
            },
            edit_contact(row){
                this.contact_dialog_key ++;
                this.contact = row;
                setTimeout(() => {
                    if(this.$refs["ContactDialog"]){
                        this.$refs["ContactDialog"].show();
                    }
                }, 100); // 1000毫秒即1秒
            },
            contactDialogChange(){
                this.getContacts({customer_id: this.customerId});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/customer/Workspace.vue